'use strict';

var React = require('react');
var IconBase = require('./dist/IconBase.js');

module.exports = function (props) {
    return React.createElement(IconBase, Object.assign({ viewBox: '0 0 1024 1024' }, props, {
        style: { width: '1em' }
    }), React.createElement(
        'g',
        null,
        React.createElement('path', { d: 'M400 256h560v576h-560c-9.44 0-30.012-8.522-36.686-15.196l-272.804-272.804 272.804-272.804c6.674-6.674 27.246-15.196 36.686-15.196v0zM400 192v0c-26.4 0-63.274 15.274-81.942 33.942l-284.118 284.116c-18.668 18.668-18.668 49.214 0 67.882l284.12 284.12c18.666 18.666 55.54 33.94 81.94 33.94h576c26.4 0 48-21.6 48-48v-608c0-26.4-21.6-48-48-48h-576z' }),
        React.createElement('path', { d: 'M896 416l-96-96-128 128-128-128-96 96 128 128-128 128 96 96 128-128 128 128 96-96-128-128z' })
    ));
};